/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import Cookies from 'js-cookie';
import ReactLoading from 'react-loading';
import InfiniteScroll from 'react-infinite-scroller';
import { toast } from 'react-toastify';
import { DatePicker } from '@material-ui/pickers';
import moment from 'moment';
import 'moment/locale/pt-br';
import api from 'api';
import { Header, SideMenu, InstallmentItem, Search, Button, Dialog, Select } from 'components';
import { Container, ContentArea, Title, Div, DataArea, LoadingArea, CountArea, ModalButton, FilterModalForm, FilterDivPicker, DivPicker } from './styles';
import { loadingColor, primary, white } from 'styles/colorProvider';
import { TiFilter } from 'react-icons/ti';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { hasPermission, Permissions } from 'utils/permissions';

const formatDateParam = (date) => (date ? moment(date).format('DD/MM/YYYY') : undefined);

function Installments() {
  const scrollParent = useRef();

  const [loading, setLoading] = useState(false);
  const [loadingReport, setLoadingReport] = useState(false);
  const [installmentsList, setInstallmentsList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [hasNextPage, setHasNextPage] = useState();
  const [search, setSearch] = useState();
  const [open, setOpen] = useState(false);
  const [openReport, setOpenReport] = useState(false);
  const [selectBaixada, setSelectBaixada] = useState('all');
  const [filterStartDate, setFilterStartDate] = useState(null);
  const [filterEndDate, setFilterEndDate] = useState(null);
  const [reportStartDate, setReportStartDate] = useState(null);
  const [reportEndDate, setReportEndDate] = useState(null);
  const [touchFilter, setTouchFilter] = useState();

  const canExportInstallmentsByDateRange = hasPermission(Permissions.EXPORT_INSTALLMENTS_BY_DATE_RANGE_BACKOFFICE);

  const loadData = async () => {
    setLoading(true);
    setCurrentPage(1);
    const resp = await api({
      method: 'GET',
      url: `/broker-installments`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitriskwl-authtoken'),
      },
      params: {
        search,
        startdate: formatDateParam(filterStartDate),
        enddate: formatDateParam(filterEndDate),
        baixada: selectBaixada === 'all' ? undefined : selectBaixada,
        page: 1,
        take: 10,
      },
      json: true,
    });

    setInstallmentsList(resp?.data?.installments);
    setTotalCount(resp?.data?.totalCount);
    setHasNextPage(resp?.data?.hasNextPage);
    setLoading(false);
    setTouchFilter(false);
  };

  const handleLoadMore = async () => {
    if (!touchFilter) {
      const page = currentPage + 1;
      if (hasNextPage && !loadingMore) {
        setLoadingMore(true);

        const resp = await api({
          method: 'GET',
          url: `/broker-installments`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitriskwl-authtoken'),
          },
          params: {
            search,
            startdate: formatDateParam(filterStartDate),
            enddate: formatDateParam(filterEndDate),
            baixada: selectBaixada === 'all' ? undefined : selectBaixada,
            page,
            take: 10,
          },
          json: true,
        });

        const data = installmentsList;
        const ndata = data.concat(resp?.data?.installments);

        setCurrentPage(page);
        setInstallmentsList(ndata);
        setHasNextPage(resp?.data?.hasNextPage);
        setLoadingMore(false);
      }
    }
  };

  const handleClear = () => {
    setSelectBaixada('all');
    setFilterStartDate(null);
    setFilterEndDate(null);
  };

  const handleGenerateReport = async () => {
    if (!reportStartDate || !reportEndDate) {
      toast.error('Informe a data inicial e final.', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      return;
    }

    setLoadingReport(true);

    try {
      const resp = await api({
        method: 'GET',
        url: `/export-installments-by-date-range`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitriskwl-authtoken'),
        },
        params: {
          startdate: formatDateParam(reportStartDate),
          enddate: formatDateParam(reportEndDate),
        },
        json: true,
      });

      if (resp?.data?.url) {
        const link = document.createElement('a');
        link.href = resp.data.url;
        link.setAttribute('download', 'relatorio-parcelas.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setOpenReport(false);
        setReportStartDate(null);
        setReportEndDate(null);
      }
    } catch (error) {
      toast.error('Não foi possível gerar o relatório', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    }

    setLoadingReport(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleOpenFilter = () => {
    setOpen(true);
  };

  const renderFilterDialog = () => (
    <Dialog open={open} onClose={() => setOpen(false)} width="50%" title="Filtrar parcelas">
      <FilterModalForm>
        <Select height="30px" width="300px" label="Baixada" value={selectBaixada} onChange={(e) => setSelectBaixada(e.target.value)}>
          <option value={'all'}>Todas</option>
          <option value={'true'}>Baixadas</option>
          <option value={'false'}>Não baixadas</option>
        </Select>

        <FilterDivPicker>
          <DatePicker
            emptyLabel="DD/MM/AAAA"
            label="Data de vencimento inicial"
            value={filterStartDate}
            onChange={setFilterStartDate}
            inputVariant="outlined"
            format="dd/MM/yyyy"
            invalidDateMessage="Data inválida"
            clearable
            cancelLabel="Cancelar"
            okLabel="OK"
          />
        </FilterDivPicker>

        <FilterDivPicker>
          <DatePicker
            emptyLabel="DD/MM/AAAA"
            label="Data de vencimento final"
            value={filterEndDate}
            onChange={setFilterEndDate}
            minDate={filterStartDate || undefined}
            inputVariant="outlined"
            format="dd/MM/yyyy"
            invalidDateMessage="Data inválida"
            clearable
            cancelLabel="Cancelar"
            okLabel="OK"
          />
        </FilterDivPicker>
      </FilterModalForm>
      <ModalButton style={{ marginTop: '1rem' }}>
        <Button
          height="35px"
          outlined
          disabled={selectBaixada === 'all' && !filterStartDate && !filterEndDate}
          onClick={handleClear}
        >
          Limpar filtros
        </Button>
        <Button
          height="35px"
          onClick={() => {
            setTouchFilter(true);
            loadData();
            setOpen(false);
          }}
        >
          Aplicar alterações
        </Button>
      </ModalButton>
    </Dialog>
  );

  const renderReportDialog = () => (
    <Dialog
      open={openReport}
      onClose={() => {
        if (!loadingReport) {
          setOpenReport(false);
          setReportStartDate(null);
          setReportEndDate(null);
        }
      }}
      width="50%"
      title="Gerar relatório"
    >
      <DivPicker>
        <DatePicker
          emptyLabel="DD/MM/AAAA"
          label="Data inicial"
          value={reportStartDate}
          onChange={setReportStartDate}
          inputVariant="outlined"
          format="dd/MM/yyyy"
          invalidDateMessage="Data inválida"
          clearable
          cancelLabel="Cancelar"
          okLabel="OK"
        />
      </DivPicker>

      <DivPicker>
        <DatePicker
          emptyLabel="DD/MM/AAAA"
          label="Data final"
          value={reportEndDate}
          onChange={setReportEndDate}
          minDate={reportStartDate || undefined}
          inputVariant="outlined"
          format="dd/MM/yyyy"
          invalidDateMessage="Data inválida"
          clearable
          cancelLabel="Cancelar"
          okLabel="OK"
        />
      </DivPicker>
      <ModalButton>
        <Button height="35px" onClick={handleGenerateReport} disabled={loadingReport || !reportStartDate || !reportEndDate}>
          {loadingReport ? <ReactLoading color={white} height={25} width={25} type="spin" /> : 'Gerar relatório'}
        </Button>
      </ModalButton>
    </Dialog>
  );

  return (
    <>
      <Header />
      <Container>
        {renderFilterDialog()}
        {canExportInstallmentsByDateRange && renderReportDialog()}
        <SideMenu />

        <ContentArea>
          <Div>
            <Title>PARCELAS</Title>
            <div className="containerTitle">
              {canExportInstallmentsByDateRange && (
                <Button title="Gerar Relatório" height="30px" style={{ marginRight: -5 }} onClick={() => setOpenReport(true)}>
                  <RiFileExcel2Fill size={18} />
                </Button>
              )}
              <Button title="Filtrar" height="30px" onClick={handleOpenFilter}>
                <TiFilter size={18} />
              </Button>
              <Search
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onClear={() => {
                  setSearch('');
                  loadData();
                }}
                onConfirm={() => loadData()}
              />
            </div>
          </Div>

          <DataArea ref={scrollParent}>
            <InfiniteScroll
              loadMore={handleLoadMore}
              hasMore={hasNextPage}
              useWindow={false}
              getScrollParent={() => scrollParent?.current}
              initialLoad={false}
              style={{ width: '100%', display: 'flex' }}
              threshold={10}
            >
              <div style={{ width: '100%' }}>
                {loading && (
                  <LoadingArea>
                    <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
                  </LoadingArea>
                )}
                {!loading &&
                  installmentsList?.map((installment) => (
                    <InstallmentItem key={installment.id} installment={installment} />
                  ))}
              </div>
            </InfiniteScroll>

            {!loading && !installmentsList?.length && <p>Nenhuma parcela encontrada</p>}
          </DataArea>
          <CountArea>
            {loadingMore && <ReactLoading color={loadingColor} height={20} width={20} type="spin" />}

            {!loadingMore && !loading && (
              <p style={{ color: primary }}>
                Mostrando {installmentsList?.length} de {totalCount}
              </p>
            )}
          </CountArea>
        </ContentArea>
      </Container>
    </>
  );
}

export default Installments;
